import { findIndex, cloneDeep } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  plantId: -1,
  stopperId: -1,
  boxId: -1,
  plantIdBackup: -1,
  stopperIdBackup: -1,
  boxIdBackup: -1,
  solution: null,
  solutions: null,
  tubeLabel: ''
};

export function GlassTubeReducer(
  state = { glassTubes: [] },
  action
) {
  let currentGlassTube;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_GLASSTUBE" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("glassTubes")
      ) {
        currentGlassTube =
          state.protocolSection.scene.apparatus.glassTubes[
            findIndex(state.protocolSection.scene.apparatus.glassTubes, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_GLASSTUBE":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("glassTubes")) {
        protocolSection.scene.apparatus.glassTubes = [
          ...protocolSection.scene.apparatus.glassTubes,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.glassTubes = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

      case "GLASSTUBE_DROP_ITEM":
        //Create new obj from template state
        // let newObj = { ...templateState, ...action.payload.props };

        currentGlassTube = state.protocolSection.scene.apparatus.glassTubes[action.payload.tubeID-1];
        switch(action.payload.type){
          case "plant":
            currentGlassTube.plantId = action.payload.plantId;
            break;
          case "box":
            currentGlassTube.boxId = action.payload.boxId;
          break;
          case "stopper":
            currentGlassTube.stopperId = action.payload.stopperId;
            break;
        }
          console.log("current tube\n" +  currentGlassTube)

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };

        case "GLASSTUBE_SET_PH":

          currentGlassTube = state.protocolSection.scene.apparatus.glassTubes[action.payload.id-1];

          for(var solution in currentGlassTube.solutions){
            currentGlassTube.solutions[solution].pH = action.payload.pH
          }

          currentGlassTube.solutions = cloneDeep(currentGlassTube.solutions);
          currentGlassTube.plantIdBackup = currentGlassTube.plantId;
          currentGlassTube.stopperIdBackup = currentGlassTube.stopperId;
          currentGlassTube.boxIdBackup = currentGlassTube.boxId;

          protocolSection.scene.apparatus.glassTubes[findIndex(protocolSection.scene.apparatus.glassTubes, { id: action.payload.id })] = currentGlassTube

          return {
            ...state,
            ...{
              protocolSection: protocolSection,
            },
          };

        case "GLASSTUBE_REMOVE_ITEM":
          //Create new obj from template state
          // let newObj = { ...templateState, ...action.payload.props };

          currentGlassTube = state.protocolSection.scene.apparatus.glassTubes[action.payload.id-1];
          switch(action.payload.type){
            case "plant":
              currentGlassTube.plantId = -1;
              break;
            case "box":
              currentGlassTube.boxId = -1;
              break;
            case "stopper":
              currentGlassTube.stopperId = -1;
              break;
          }


          return {
            ...state,
            ...{
              protocolSection: protocolSection,
            },
          };


    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('glassTubes')) {
        protocolSection.scene.apparatus.glassTubes =
          action.payload.lastState.scene.apparatus.glassTubes;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
